import { Detector } from 'detector-js'

const platform = new Detector()

export default platform
